import { createStore } from 'vuex';
import type { OAuthToken } from '@/data/models/OAuthToken';
import { http } from './http';
import useFormatDateToString from '@/composables/useFormatDateToString';

export interface State {
  token?: OAuthToken;
  isTest: boolean;
  testDate: Date;
}

export default createStore<State>({
  strict: true,

  state(): State {
    return {
      token: undefined,
      isTest: process.env.VUE_APP_ENV === 'test',
      testDate: localStorage.getItem('testDate') ? new Date(localStorage.getItem('testDate') as string) : new Date(),
    };
  },

  getters: {
    sessionInfo(state: State): OAuthToken | undefined {
      return state.token;
    },
  },

  actions: {
    async restore({ commit }): Promise<void> {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          await commit('setToken', { token: JSON.parse(token) });
        } catch (e) {
          await commit('logout');
        }
      }
    },

    async logout({ commit }): Promise<void> {
      commit('logout');

      location.reload();
    },
  },

  mutations: {
    setToken(state, { token }: { token: OAuthToken }): void {
      http.defaults.headers.common.Authorization = token.access_token;

      localStorage.setItem('token', JSON.stringify(token));

      state.token = token;
    },

    logout(): void {
      delete http.defaults.headers.common.Authorization;

      localStorage.removeItem('token');
    },

    setTestDate(state, { date }: { date: Date }): void {
      state.testDate = date;

      localStorage.setItem('testDate', useFormatDateToString(date));
    },
  },
});
